// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__3NjgZ","checkboxInput--secondary":"Checkbox_checkboxInput--secondary__tGirI","checkboxInputChecked":"Checkbox_checkboxInputChecked__2IEiF"};